import type {
  TripContext,
  WatchAlertView,
} from "@b2bportal/air-price-watch-api";
import {
  IconNameEnum,
  useAirPriceWatchStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreAirPriceWatchComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useWatchCard, WatchActions } from "@tenant/air-price-watch";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./WatchCard.module.scss";

export interface WatchCardComponentProps extends PlatformComponentProps {
  watch: WatchAlertView;
  tripContext: TripContext;
  showActions: boolean;
  refetch: () => void;
}

const COMPONENT_KEY = CoreAirPriceWatchComponent.WatchCard;

export const WatchCard = (props: WatchCardComponentProps) => {
  const styles = useAirPriceWatchStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { className, watch, showActions, tripContext, refetch } = props;
  const { t } = useI18nContext();
  const { text } = useWatchCard(props);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("watch-icon")}>
        <Icon iconName={IconNameEnum.airplaneDiagonal} />
      </div>
      <div className={cn("recommendation")}>{text.recommendation}</div>
      <div className={cn("title")}>{text.title}</div>
      <div className={cn("watch-information")}>
        <div className={cn("departure-information")}>
          <div className={cn("label")}>{t("departingLabel")}</div>
          <div className={cn("value")}>{text.departureDate}</div>
          <div className={cn("value")}>{text.departureTime}</div>
        </div>
        {text.returnDate && text.returnTime && (
          <div className={cn("return-information")}>
            <div className={cn("label")}>{t("returningLabel")}</div>
            <div className={cn("value")}>{text.returnDate}</div>
            <div className={cn("value")}>{text.returnTime}</div>
          </div>
        )}
        <div className={cn("trip-type-information")}>
          <div className={cn("label")}>{t("tripTypeLabel")}</div>
          <div className={cn("value")}>{text.tripType}</div>
        </div>
      </div>
      {showActions && (
        <div className={cn("watch-actions")}>
          <WatchActions
            watch={watch}
            tripContext={tripContext}
            refetch={refetch}
          />
        </div>
      )}
    </div>
  );
};
